<template>
  <v-container fluid>
    <VineyardGrapeItemComponent/>
    <VineyardGrapeTableComponent/>
  </v-container>
</template>

<script>
	// @ is an alias to /src
	import VineyardGrapeItemComponent from "@/components/VineyardGrapeItemComponent.vue";
	import VineyardGrapeTableComponent from "@/components/VineyardGrapeTableComponent.vue";

	export default {
		name: "wine",
		components: {
			VineyardGrapeItemComponent,
			VineyardGrapeTableComponent
		}
	};
</script>

<style scoped lang='scss'>
</style>
